// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import {
  CoachCategorySpecificInfoCategoryInfoFragmentDoc,
  CoachCategorySpecificInfoCoachFragmentDoc,
} from '../../coach/__generated-gql-types__/CoachCategorySpecificInfo.generated';
import { ReviewSliderCoachFragmentDoc } from '../../coach/__generated-gql-types__/ReviewSlider.generated';
import { AllCoachReviewsModalCoachFragmentDoc } from '../../coach/modals/__generated-gql-types__/AllCoachReviewsModal.generated';
import { MultiEventRegistrationModalClassFragmentDoc } from './MultiEventRegistrationModal.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ClassPageCoachFragment = {
  __typename?: 'Coach';
  id: string;
  bio?: string | null;
  slug: string;
  averageReviewRate: number;
  reviewTotal: number;
  professionalCoach: boolean;
  openToInternational: boolean;
  averageKnowledgeReviewRate: number;
  averageValueReviewRate: number;
  averageResponsivenessReviewRate: number;
  averageSupportivenessReviewRate: number;
  user: {
    __typename?: 'User';
    firstName: string;
    lastName: string;
    pictureLink?: string | null;
    id: string;
  };
  categoryInformationList?: Array<{
    __typename?: 'CategoryInformation';
    headline?: string | null;
    testScore?: number | null;
    experienceLevel?: number | null;
    customersCoached?: number | null;
    qualifications?: string | null;
    category: {
      __typename?: 'Category';
      id: string;
      name: string;
      goal: Types.GoalName;
      subCategoryTitle?: string | null;
      subCategoryList?: Array<{
        __typename?: 'SubCategory';
        id: string;
        name: string;
      }> | null;
    };
  }> | null;
  coachingRelationship?: {
    __typename?: 'CoachingRelationship';
    id: string;
    blockedByCoach: boolean;
    review?: { __typename?: 'Review'; id: string } | null;
  } | null;
  mostRecentOrder?: { __typename?: 'Order'; id: string } | null;
  outcomes?: Array<
    | {
        __typename?: 'CareerOutcomeSummary';
        number: number;
        companies: Array<{
          __typename?: 'Company';
          id?: string | null;
          name: string;
          logoLink?: string | null;
        }>;
      }
    | {
        __typename?: 'SchoolOutcomeSummary';
        number: number;
        schools: Array<{
          __typename?: 'School';
          id: string;
          name: string;
          logoLink?: string | null;
        }>;
      }
    | {
        __typename?: 'TestOutcomeSummary';
        scoreRange?: string | null;
        number: number;
        category: { __typename?: 'Category'; id: string; name: string };
      }
  > | null;
};

export type ClassPageSessionFragment = {
  __typename?: 'CoachingSession';
  id: string;
  startAt: number;
  userIsEnrolled?: boolean | null;
  totalAttendees: number;
  meetingLink?: string | null;
  topFacePiles: Array<string>;
};

export type ClassPageStaticClassFragment = {
  __typename?: 'Class';
  id: string;
  name?: string | null;
  slug?: string | null;
  imageLink?: string | null;
  description?: string | null;
  keyTakeaways?: Array<string> | null;
  targetAudience?: string | null;
  durationInMinute?: number | null;
  price?: number | null;
  maximumAttendees?: number | null;
  isFreeEvent?: boolean | null;
  coachingFocusList?: Array<{
    __typename?: 'CoachingFocus';
    id: string;
    name: string;
  }> | null;
  category?: {
    __typename?: 'Category';
    id: string;
    name: string;
    slug: string;
    goal: Types.GoalName;
    subCategoryList?: Array<{
      __typename?: 'SubCategory';
      id: string;
      slug: string;
      v2Urn: string;
      name: string;
    }> | null;
  } | null;
  coach?: {
    __typename?: 'Coach';
    id: string;
    bio?: string | null;
    slug: string;
    averageReviewRate: number;
    reviewTotal: number;
    professionalCoach: boolean;
    openToInternational: boolean;
    averageKnowledgeReviewRate: number;
    averageValueReviewRate: number;
    averageResponsivenessReviewRate: number;
    averageSupportivenessReviewRate: number;
    user: {
      __typename?: 'User';
      firstName: string;
      lastName: string;
      pictureLink?: string | null;
      id: string;
    };
    categoryInformationList?: Array<{
      __typename?: 'CategoryInformation';
      headline?: string | null;
      testScore?: number | null;
      experienceLevel?: number | null;
      customersCoached?: number | null;
      qualifications?: string | null;
      category: {
        __typename?: 'Category';
        id: string;
        name: string;
        goal: Types.GoalName;
        subCategoryTitle?: string | null;
        subCategoryList?: Array<{
          __typename?: 'SubCategory';
          id: string;
          name: string;
        }> | null;
      };
    }> | null;
    coachingRelationship?: {
      __typename?: 'CoachingRelationship';
      id: string;
      blockedByCoach: boolean;
      review?: { __typename?: 'Review'; id: string } | null;
    } | null;
    mostRecentOrder?: { __typename?: 'Order'; id: string } | null;
    outcomes?: Array<
      | {
          __typename?: 'CareerOutcomeSummary';
          number: number;
          companies: Array<{
            __typename?: 'Company';
            id?: string | null;
            name: string;
            logoLink?: string | null;
          }>;
        }
      | {
          __typename?: 'SchoolOutcomeSummary';
          number: number;
          schools: Array<{
            __typename?: 'School';
            id: string;
            name: string;
            logoLink?: string | null;
          }>;
        }
      | {
          __typename?: 'TestOutcomeSummary';
          scoreRange?: string | null;
          number: number;
          category: { __typename?: 'Category'; id: string; name: string };
        }
    > | null;
  } | null;
  upcomingSessionsV2?: Array<{
    __typename?: 'CoachingSession';
    id: string;
    startAt: number;
    totalAttendees: number;
    topFacePiles: Array<string>;
    userIsEnrolled?: boolean | null;
    meetingLink?: string | null;
  }> | null;
  userEnrolledInSessionsV2?: Array<{
    __typename?: 'CoachingSession';
    id: string;
    startAt: number;
    totalAttendees: number;
    topFacePiles: Array<string>;
  }> | null;
};

export type ClassPageHydratedClassFragment = {
  __typename?: 'Class';
  id: string;
  name?: string | null;
  slug?: string | null;
  imageLink?: string | null;
  description?: string | null;
  keyTakeaways?: Array<string> | null;
  targetAudience?: string | null;
  durationInMinute?: number | null;
  price?: number | null;
  maximumAttendees?: number | null;
  isFreeEvent?: boolean | null;
  userEnrolledInSessionsV2?: Array<{
    __typename?: 'CoachingSession';
    id: string;
    startAt: number;
    totalAttendees: number;
    topFacePiles: Array<string>;
    userIsEnrolled?: boolean | null;
    meetingLink?: string | null;
  }> | null;
  coachingFocusList?: Array<{
    __typename?: 'CoachingFocus';
    id: string;
    name: string;
  }> | null;
  category?: {
    __typename?: 'Category';
    id: string;
    name: string;
    slug: string;
    goal: Types.GoalName;
    subCategoryList?: Array<{
      __typename?: 'SubCategory';
      id: string;
      slug: string;
      v2Urn: string;
      name: string;
    }> | null;
  } | null;
  coach?: {
    __typename?: 'Coach';
    id: string;
    bio?: string | null;
    slug: string;
    averageReviewRate: number;
    reviewTotal: number;
    professionalCoach: boolean;
    openToInternational: boolean;
    averageKnowledgeReviewRate: number;
    averageValueReviewRate: number;
    averageResponsivenessReviewRate: number;
    averageSupportivenessReviewRate: number;
    user: {
      __typename?: 'User';
      firstName: string;
      lastName: string;
      pictureLink?: string | null;
      id: string;
    };
    categoryInformationList?: Array<{
      __typename?: 'CategoryInformation';
      headline?: string | null;
      testScore?: number | null;
      experienceLevel?: number | null;
      customersCoached?: number | null;
      qualifications?: string | null;
      category: {
        __typename?: 'Category';
        id: string;
        name: string;
        goal: Types.GoalName;
        subCategoryTitle?: string | null;
        subCategoryList?: Array<{
          __typename?: 'SubCategory';
          id: string;
          name: string;
        }> | null;
      };
    }> | null;
    coachingRelationship?: {
      __typename?: 'CoachingRelationship';
      id: string;
      blockedByCoach: boolean;
      review?: { __typename?: 'Review'; id: string } | null;
    } | null;
    mostRecentOrder?: { __typename?: 'Order'; id: string } | null;
    outcomes?: Array<
      | {
          __typename?: 'CareerOutcomeSummary';
          number: number;
          companies: Array<{
            __typename?: 'Company';
            id?: string | null;
            name: string;
            logoLink?: string | null;
          }>;
        }
      | {
          __typename?: 'SchoolOutcomeSummary';
          number: number;
          schools: Array<{
            __typename?: 'School';
            id: string;
            name: string;
            logoLink?: string | null;
          }>;
        }
      | {
          __typename?: 'TestOutcomeSummary';
          scoreRange?: string | null;
          number: number;
          category: { __typename?: 'Category'; id: string; name: string };
        }
    > | null;
  } | null;
  upcomingSessionsV2?: Array<{
    __typename?: 'CoachingSession';
    id: string;
    startAt: number;
    totalAttendees: number;
    topFacePiles: Array<string>;
    userIsEnrolled?: boolean | null;
    meetingLink?: string | null;
  }> | null;
};

export type ClassPageCreateOrderMutationVariables = Types.Exact<{
  coachUrn: Types.Scalars['CoachUrn']['input'];
  classOrder: Types.ClassOrderInput;
  numberOfCharges: Types.Scalars['Int']['input'];
}>;

export type ClassPageCreateOrderMutation = {
  __typename?: 'Mutation';
  createOrder: { __typename?: 'Order'; id: string };
};

export type ClassPageGetStaticClassBySlugQueryVariables = Types.Exact<{
  classSlug: Types.Scalars['String']['input'];
}>;

export type ClassPageGetStaticClassBySlugQuery = {
  __typename?: 'Query';
  groupClassBySlug: {
    __typename?: 'Class';
    id: string;
    name?: string | null;
    slug?: string | null;
    imageLink?: string | null;
    description?: string | null;
    keyTakeaways?: Array<string> | null;
    targetAudience?: string | null;
    durationInMinute?: number | null;
    price?: number | null;
    maximumAttendees?: number | null;
    isFreeEvent?: boolean | null;
    coachingFocusList?: Array<{
      __typename?: 'CoachingFocus';
      id: string;
      name: string;
    }> | null;
    category?: {
      __typename?: 'Category';
      id: string;
      name: string;
      slug: string;
      goal: Types.GoalName;
      subCategoryList?: Array<{
        __typename?: 'SubCategory';
        id: string;
        slug: string;
        v2Urn: string;
        name: string;
      }> | null;
    } | null;
    coach?: {
      __typename?: 'Coach';
      id: string;
      bio?: string | null;
      slug: string;
      averageReviewRate: number;
      reviewTotal: number;
      professionalCoach: boolean;
      openToInternational: boolean;
      averageKnowledgeReviewRate: number;
      averageValueReviewRate: number;
      averageResponsivenessReviewRate: number;
      averageSupportivenessReviewRate: number;
      user: {
        __typename?: 'User';
        firstName: string;
        lastName: string;
        pictureLink?: string | null;
        id: string;
      };
      categoryInformationList?: Array<{
        __typename?: 'CategoryInformation';
        headline?: string | null;
        testScore?: number | null;
        experienceLevel?: number | null;
        customersCoached?: number | null;
        qualifications?: string | null;
        category: {
          __typename?: 'Category';
          id: string;
          name: string;
          goal: Types.GoalName;
          subCategoryTitle?: string | null;
          subCategoryList?: Array<{
            __typename?: 'SubCategory';
            id: string;
            name: string;
          }> | null;
        };
      }> | null;
      coachingRelationship?: {
        __typename?: 'CoachingRelationship';
        id: string;
        blockedByCoach: boolean;
        review?: { __typename?: 'Review'; id: string } | null;
      } | null;
      mostRecentOrder?: { __typename?: 'Order'; id: string } | null;
      outcomes?: Array<
        | {
            __typename?: 'CareerOutcomeSummary';
            number: number;
            companies: Array<{
              __typename?: 'Company';
              id?: string | null;
              name: string;
              logoLink?: string | null;
            }>;
          }
        | {
            __typename?: 'SchoolOutcomeSummary';
            number: number;
            schools: Array<{
              __typename?: 'School';
              id: string;
              name: string;
              logoLink?: string | null;
            }>;
          }
        | {
            __typename?: 'TestOutcomeSummary';
            scoreRange?: string | null;
            number: number;
            category: { __typename?: 'Category'; id: string; name: string };
          }
      > | null;
    } | null;
    upcomingSessionsV2?: Array<{
      __typename?: 'CoachingSession';
      id: string;
      startAt: number;
      totalAttendees: number;
      topFacePiles: Array<string>;
      userIsEnrolled?: boolean | null;
      meetingLink?: string | null;
    }> | null;
    userEnrolledInSessionsV2?: Array<{
      __typename?: 'CoachingSession';
      id: string;
      startAt: number;
      totalAttendees: number;
      topFacePiles: Array<string>;
    }> | null;
  };
};

export type ClassPageGetHydratedClassBySlugQueryVariables = Types.Exact<{
  classSlug: Types.Scalars['String']['input'];
}>;

export type ClassPageGetHydratedClassBySlugQuery = {
  __typename?: 'Query';
  groupClassBySlug: {
    __typename?: 'Class';
    id: string;
    name?: string | null;
    slug?: string | null;
    imageLink?: string | null;
    description?: string | null;
    keyTakeaways?: Array<string> | null;
    targetAudience?: string | null;
    durationInMinute?: number | null;
    price?: number | null;
    maximumAttendees?: number | null;
    isFreeEvent?: boolean | null;
    userEnrolledInSessionsV2?: Array<{
      __typename?: 'CoachingSession';
      id: string;
      startAt: number;
      totalAttendees: number;
      topFacePiles: Array<string>;
      userIsEnrolled?: boolean | null;
      meetingLink?: string | null;
    }> | null;
    coachingFocusList?: Array<{
      __typename?: 'CoachingFocus';
      id: string;
      name: string;
    }> | null;
    category?: {
      __typename?: 'Category';
      id: string;
      name: string;
      slug: string;
      goal: Types.GoalName;
      subCategoryList?: Array<{
        __typename?: 'SubCategory';
        id: string;
        slug: string;
        v2Urn: string;
        name: string;
      }> | null;
    } | null;
    coach?: {
      __typename?: 'Coach';
      id: string;
      bio?: string | null;
      slug: string;
      averageReviewRate: number;
      reviewTotal: number;
      professionalCoach: boolean;
      openToInternational: boolean;
      averageKnowledgeReviewRate: number;
      averageValueReviewRate: number;
      averageResponsivenessReviewRate: number;
      averageSupportivenessReviewRate: number;
      user: {
        __typename?: 'User';
        firstName: string;
        lastName: string;
        pictureLink?: string | null;
        id: string;
      };
      categoryInformationList?: Array<{
        __typename?: 'CategoryInformation';
        headline?: string | null;
        testScore?: number | null;
        experienceLevel?: number | null;
        customersCoached?: number | null;
        qualifications?: string | null;
        category: {
          __typename?: 'Category';
          id: string;
          name: string;
          goal: Types.GoalName;
          subCategoryTitle?: string | null;
          subCategoryList?: Array<{
            __typename?: 'SubCategory';
            id: string;
            name: string;
          }> | null;
        };
      }> | null;
      coachingRelationship?: {
        __typename?: 'CoachingRelationship';
        id: string;
        blockedByCoach: boolean;
        review?: { __typename?: 'Review'; id: string } | null;
      } | null;
      mostRecentOrder?: { __typename?: 'Order'; id: string } | null;
      outcomes?: Array<
        | {
            __typename?: 'CareerOutcomeSummary';
            number: number;
            companies: Array<{
              __typename?: 'Company';
              id?: string | null;
              name: string;
              logoLink?: string | null;
            }>;
          }
        | {
            __typename?: 'SchoolOutcomeSummary';
            number: number;
            schools: Array<{
              __typename?: 'School';
              id: string;
              name: string;
              logoLink?: string | null;
            }>;
          }
        | {
            __typename?: 'TestOutcomeSummary';
            scoreRange?: string | null;
            number: number;
            category: { __typename?: 'Category'; id: string; name: string };
          }
      > | null;
    } | null;
    upcomingSessionsV2?: Array<{
      __typename?: 'CoachingSession';
      id: string;
      startAt: number;
      totalAttendees: number;
      topFacePiles: Array<string>;
      userIsEnrolled?: boolean | null;
      meetingLink?: string | null;
    }> | null;
  };
};

export type ClassPageUnenrollFreeEventMutationVariables = Types.Exact<{
  id: Types.Scalars['CoachingSessionUrn']['input'];
}>;

export type ClassPageUnenrollFreeEventMutation = {
  __typename?: 'Mutation';
  unenrollFreeEvent: {
    __typename?: 'CoachingSession';
    id: string;
    userIsEnrolled?: boolean | null;
  };
};

export type ClassPageEnrollFreeEventMutationVariables = Types.Exact<{
  id: Types.Scalars['CoachingSessionUrn']['input'];
}>;

export type ClassPageEnrollFreeEventMutation = {
  __typename?: 'Mutation';
  enrollFreeEvent: {
    __typename?: 'CoachingSession';
    id: string;
    userIsEnrolled?: boolean | null;
  };
};

export const ClassPageCoachFragmentDoc = gql`
  fragment ClassPage_Coach on Coach {
    id
    user {
      firstName
      lastName
      pictureLink
    }
    bio
    categoryInformationList(showHidden: false) {
      headline
      ...CoachCategorySpecificInfo_CategoryInfo
    }
    coachingRelationship {
      id
      blockedByCoach
    }
    slug
    averageReviewRate
    reviewTotal
    ...ReviewSlider_Coach
    ...AllCoachReviewsModal_Coach
    ...CoachCategorySpecificInfo_Coach
  }
  ${CoachCategorySpecificInfoCategoryInfoFragmentDoc}
  ${ReviewSliderCoachFragmentDoc}
  ${AllCoachReviewsModalCoachFragmentDoc}
  ${CoachCategorySpecificInfoCoachFragmentDoc}
`;
export const ClassPageSessionFragmentDoc = gql`
  fragment ClassPage_Session on CoachingSession {
    id
    startAt
    userIsEnrolled
    totalAttendees
    meetingLink
    topFacePiles(count: 3)
  }
`;
export const ClassPageStaticClassFragmentDoc = gql`
  fragment ClassPage_StaticClass on Class {
    id
    name
    slug
    imageLink
    description
    keyTakeaways
    targetAudience
    durationInMinute
    price
    maximumAttendees
    coachingFocusList {
      id
      name
    }
    category {
      id
      name
      slug
      goal
    }
    coach {
      ...ClassPage_Coach
    }
    upcomingSessionsV2 {
      ...ClassPage_Session
    }
    isFreeEvent
    userEnrolledInSessionsV2 {
      id
      startAt
      totalAttendees
      topFacePiles(count: 3)
    }
    ...MultiEventRegistrationModal_Class
  }
  ${ClassPageCoachFragmentDoc}
  ${ClassPageSessionFragmentDoc}
  ${MultiEventRegistrationModalClassFragmentDoc}
`;
export const ClassPageHydratedClassFragmentDoc = gql`
  fragment ClassPage_HydratedClass on Class {
    ...ClassPage_StaticClass
    userEnrolledInSessionsV2 {
      ...ClassPage_Session
    }
  }
  ${ClassPageStaticClassFragmentDoc}
  ${ClassPageSessionFragmentDoc}
`;
export const ClassPageCreateOrderDocument = gql`
  mutation ClassPage_CreateOrder(
    $coachUrn: CoachUrn!
    $classOrder: ClassOrderInput!
    $numberOfCharges: Int!
  ) {
    createOrder(
      coachUrn: $coachUrn
      classOrder: $classOrder
      numberOfCharges: $numberOfCharges
    ) {
      id
    }
  }
`;
export type ClassPageCreateOrderMutationFn = Apollo.MutationFunction<
  ClassPageCreateOrderMutation,
  ClassPageCreateOrderMutationVariables
>;

/**
 * __useClassPageCreateOrderMutation__
 *
 * To run a mutation, you first call `useClassPageCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClassPageCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [classPageCreateOrderMutation, { data, loading, error }] = useClassPageCreateOrderMutation({
 *   variables: {
 *      coachUrn: // value for 'coachUrn'
 *      classOrder: // value for 'classOrder'
 *      numberOfCharges: // value for 'numberOfCharges'
 *   },
 * });
 */
export function useClassPageCreateOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ClassPageCreateOrderMutation,
    ClassPageCreateOrderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ClassPageCreateOrderMutation,
    ClassPageCreateOrderMutationVariables
  >(ClassPageCreateOrderDocument, options);
}
export type ClassPageCreateOrderMutationHookResult = ReturnType<
  typeof useClassPageCreateOrderMutation
>;
export type ClassPageCreateOrderMutationResult =
  Apollo.MutationResult<ClassPageCreateOrderMutation>;
export type ClassPageCreateOrderMutationOptions = Apollo.BaseMutationOptions<
  ClassPageCreateOrderMutation,
  ClassPageCreateOrderMutationVariables
>;
export const ClassPageGetStaticClassBySlugDocument = gql`
  query ClassPage_GetStaticClassBySlug($classSlug: String!) {
    groupClassBySlug(slug: $classSlug) {
      ...ClassPage_StaticClass
    }
  }
  ${ClassPageStaticClassFragmentDoc}
`;

/**
 * __useClassPageGetStaticClassBySlugQuery__
 *
 * To run a query within a React component, call `useClassPageGetStaticClassBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassPageGetStaticClassBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassPageGetStaticClassBySlugQuery({
 *   variables: {
 *      classSlug: // value for 'classSlug'
 *   },
 * });
 */
export function useClassPageGetStaticClassBySlugQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClassPageGetStaticClassBySlugQuery,
    ClassPageGetStaticClassBySlugQueryVariables
  > &
    (
      | {
          variables: ClassPageGetStaticClassBySlugQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClassPageGetStaticClassBySlugQuery,
    ClassPageGetStaticClassBySlugQueryVariables
  >(ClassPageGetStaticClassBySlugDocument, options);
}
export function useClassPageGetStaticClassBySlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClassPageGetStaticClassBySlugQuery,
    ClassPageGetStaticClassBySlugQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClassPageGetStaticClassBySlugQuery,
    ClassPageGetStaticClassBySlugQueryVariables
  >(ClassPageGetStaticClassBySlugDocument, options);
}
export function useClassPageGetStaticClassBySlugSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ClassPageGetStaticClassBySlugQuery,
    ClassPageGetStaticClassBySlugQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ClassPageGetStaticClassBySlugQuery,
    ClassPageGetStaticClassBySlugQueryVariables
  >(ClassPageGetStaticClassBySlugDocument, options);
}
export type ClassPageGetStaticClassBySlugQueryHookResult = ReturnType<
  typeof useClassPageGetStaticClassBySlugQuery
>;
export type ClassPageGetStaticClassBySlugLazyQueryHookResult = ReturnType<
  typeof useClassPageGetStaticClassBySlugLazyQuery
>;
export type ClassPageGetStaticClassBySlugSuspenseQueryHookResult = ReturnType<
  typeof useClassPageGetStaticClassBySlugSuspenseQuery
>;
export type ClassPageGetStaticClassBySlugQueryResult = Apollo.QueryResult<
  ClassPageGetStaticClassBySlugQuery,
  ClassPageGetStaticClassBySlugQueryVariables
>;
export const ClassPageGetHydratedClassBySlugDocument = gql`
  query ClassPage_GetHydratedClassBySlug($classSlug: String!) {
    groupClassBySlug(slug: $classSlug) {
      ...ClassPage_HydratedClass
    }
  }
  ${ClassPageHydratedClassFragmentDoc}
`;

/**
 * __useClassPageGetHydratedClassBySlugQuery__
 *
 * To run a query within a React component, call `useClassPageGetHydratedClassBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassPageGetHydratedClassBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassPageGetHydratedClassBySlugQuery({
 *   variables: {
 *      classSlug: // value for 'classSlug'
 *   },
 * });
 */
export function useClassPageGetHydratedClassBySlugQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClassPageGetHydratedClassBySlugQuery,
    ClassPageGetHydratedClassBySlugQueryVariables
  > &
    (
      | {
          variables: ClassPageGetHydratedClassBySlugQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClassPageGetHydratedClassBySlugQuery,
    ClassPageGetHydratedClassBySlugQueryVariables
  >(ClassPageGetHydratedClassBySlugDocument, options);
}
export function useClassPageGetHydratedClassBySlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClassPageGetHydratedClassBySlugQuery,
    ClassPageGetHydratedClassBySlugQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClassPageGetHydratedClassBySlugQuery,
    ClassPageGetHydratedClassBySlugQueryVariables
  >(ClassPageGetHydratedClassBySlugDocument, options);
}
export function useClassPageGetHydratedClassBySlugSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ClassPageGetHydratedClassBySlugQuery,
    ClassPageGetHydratedClassBySlugQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ClassPageGetHydratedClassBySlugQuery,
    ClassPageGetHydratedClassBySlugQueryVariables
  >(ClassPageGetHydratedClassBySlugDocument, options);
}
export type ClassPageGetHydratedClassBySlugQueryHookResult = ReturnType<
  typeof useClassPageGetHydratedClassBySlugQuery
>;
export type ClassPageGetHydratedClassBySlugLazyQueryHookResult = ReturnType<
  typeof useClassPageGetHydratedClassBySlugLazyQuery
>;
export type ClassPageGetHydratedClassBySlugSuspenseQueryHookResult = ReturnType<
  typeof useClassPageGetHydratedClassBySlugSuspenseQuery
>;
export type ClassPageGetHydratedClassBySlugQueryResult = Apollo.QueryResult<
  ClassPageGetHydratedClassBySlugQuery,
  ClassPageGetHydratedClassBySlugQueryVariables
>;
export const ClassPageUnenrollFreeEventDocument = gql`
  mutation ClassPage_UnenrollFreeEvent($id: CoachingSessionUrn!) {
    unenrollFreeEvent(id: $id) {
      id
      userIsEnrolled
    }
  }
`;
export type ClassPageUnenrollFreeEventMutationFn = Apollo.MutationFunction<
  ClassPageUnenrollFreeEventMutation,
  ClassPageUnenrollFreeEventMutationVariables
>;

/**
 * __useClassPageUnenrollFreeEventMutation__
 *
 * To run a mutation, you first call `useClassPageUnenrollFreeEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClassPageUnenrollFreeEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [classPageUnenrollFreeEventMutation, { data, loading, error }] = useClassPageUnenrollFreeEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClassPageUnenrollFreeEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ClassPageUnenrollFreeEventMutation,
    ClassPageUnenrollFreeEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ClassPageUnenrollFreeEventMutation,
    ClassPageUnenrollFreeEventMutationVariables
  >(ClassPageUnenrollFreeEventDocument, options);
}
export type ClassPageUnenrollFreeEventMutationHookResult = ReturnType<
  typeof useClassPageUnenrollFreeEventMutation
>;
export type ClassPageUnenrollFreeEventMutationResult =
  Apollo.MutationResult<ClassPageUnenrollFreeEventMutation>;
export type ClassPageUnenrollFreeEventMutationOptions =
  Apollo.BaseMutationOptions<
    ClassPageUnenrollFreeEventMutation,
    ClassPageUnenrollFreeEventMutationVariables
  >;
export const ClassPageEnrollFreeEventDocument = gql`
  mutation ClassPage_EnrollFreeEvent($id: CoachingSessionUrn!) {
    enrollFreeEvent(id: $id) {
      id
      userIsEnrolled
    }
  }
`;
export type ClassPageEnrollFreeEventMutationFn = Apollo.MutationFunction<
  ClassPageEnrollFreeEventMutation,
  ClassPageEnrollFreeEventMutationVariables
>;

/**
 * __useClassPageEnrollFreeEventMutation__
 *
 * To run a mutation, you first call `useClassPageEnrollFreeEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClassPageEnrollFreeEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [classPageEnrollFreeEventMutation, { data, loading, error }] = useClassPageEnrollFreeEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClassPageEnrollFreeEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ClassPageEnrollFreeEventMutation,
    ClassPageEnrollFreeEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ClassPageEnrollFreeEventMutation,
    ClassPageEnrollFreeEventMutationVariables
  >(ClassPageEnrollFreeEventDocument, options);
}
export type ClassPageEnrollFreeEventMutationHookResult = ReturnType<
  typeof useClassPageEnrollFreeEventMutation
>;
export type ClassPageEnrollFreeEventMutationResult =
  Apollo.MutationResult<ClassPageEnrollFreeEventMutation>;
export type ClassPageEnrollFreeEventMutationOptions =
  Apollo.BaseMutationOptions<
    ClassPageEnrollFreeEventMutation,
    ClassPageEnrollFreeEventMutationVariables
  >;
